(function () {
  const overlay = document.getElementById('CartDrawerOverlay');
  const drawer = document.getElementById('CartDrawer');

  // Items + summary
  const itemsWrap = document.getElementById('CartDrawerItems');
  const subtotalEl = document.getElementById('CartDrawerSubtotal');
  const noteEl = document.getElementById('CartDrawerNote');
  const summaryEl = document.getElementById('CartDrawerSummary');

  // Root config (from section wrapper)
  const root = document.getElementById('CartDrawerRoot');

  // Free shipping progress UI
  const freeShipWrap = document.getElementById('CartDrawerFreeShip');
  const freeShipMsg = document.getElementById('CartDrawerFreeShipMsg');
  const freeShipFill = document.getElementById('CartDrawerFreeShipFill');

  // Upsells
  const upsellWrap = document.getElementById('CartDrawerUpsells');

  // Order Notes - Save
  const noteStatusEl = document.getElementById('CartDrawerNoteStatus');
  let noteStatusTimer = null;

  const showNoteStatus = (msg) => {
    if (!noteStatusEl) return;
    noteStatusEl.textContent = msg;
    noteStatusEl.hidden = false;

    if (noteStatusTimer) window.clearTimeout(noteStatusTimer);
    noteStatusTimer = window.setTimeout(() => {
      noteStatusEl.hidden = true;
      noteStatusEl.textContent = '';
    }, 2500);
  };

  if (!overlay || !drawer || !itemsWrap || !subtotalEl) return;

  // Basic money formatting fallback.
  const moneyFormat = (cents) => {
    const currency = window.Shopify?.currency?.active || 'GBP';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency });
  };

  const setLoading = (isLoading) => {
    drawer.classList.toggle('is-loading', !!isLoading);
  };

  const openDrawer = () => {
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    drawer.focus({ preventScroll: true });
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.documentElement.classList.remove('cart-drawer-open');
  };

  // ---------- Product / variant helpers ----------
  const getProductData = (form) => {
    const jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (err) {
      console.warn('Product JSON parse failed', err);
      return null;
    }
  };

  const cssEscapeSafe = (value) => {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/"/g, '\\"');
  };

  const getSelectedOptionValues = (form, productData) => {
    return (productData?.options || []).map((optionName, index) => {
      const escapedName = cssEscapeSafe(optionName);

      const checkedRadio = form.querySelector(`input[type="radio"][name="${escapedName}"]:checked`);
      if (checkedRadio) return checkedRadio.value;

      const selectByName = form.querySelector(`select[name="${escapedName}"]`);
      if (selectByName) return selectByName.value;

      const indexedInput =
        form.querySelector(`[name="options[${index + 1}]"]`) ||
        form.querySelector(`[name="options[${optionName}]"]`);
      if (indexedInput) return indexedInput.value;

      return '';
    });
  };

  const getMatchedVariant = (form) => {
    const productData = getProductData(form);
    if (!productData?.variants?.length) return null;

    const selectedOptions = getSelectedOptionValues(form, productData);

    return (
      productData.variants.find((variant) => {
        const variantOptions = [variant.option1, variant.option2, variant.option3].slice(0, selectedOptions.length);

        return variantOptions.every((opt, index) => String(opt || '') === String(selectedOptions[index] || ''));
      }) || null
    );
  };

  const syncVariantIdInput = (form) => {
    const matchedVariant = getMatchedVariant(form);
    const idInput = form.querySelector('[name="id"]');

    if (matchedVariant && idInput) {
      idInput.value = matchedVariant.id;
    }

    return matchedVariant;
  };

  const updateVariantUrl = (variantId) => {
    if (!variantId) return;

    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    } catch (err) {
      console.warn('Could not update variant URL', err);
    }
  };

  // ---------- Customily detection ----------
  // Fee/add-on lines have _customily-upsell-id and usually option-name/multiplier.
  const isCustomilyAddonLine = (item) => {
    const props = item.properties || {};
    const hasUpsellId = Boolean(props['_customily-upsell-id']);
    if (!hasUpsellId) return false;

    const hasOptionName = props['_customily-option-name'] != null && props['_customily-option-name'] !== '';
    const hasMultiplier = props['_customily-upsell-multiplier'] != null && props['_customily-upsell-multiplier'] !== '';
    return hasOptionName || hasMultiplier;
  };

  // Base/customised lines usually have one of these markers.
  const isCustomilyBaseLine = (item) => {
    const props = item.properties || {};
    return Boolean(
      props['_customily-personalization-id'] ||
        props['_customily-upsell-main-id'] ||
        props['_customily-thumb-id'] ||
        props['_customily-preview'] ||
        props['_customily-production-url']
    );
  };

  // Count ONLY base items (exclude add-on/fee lines)
  const getBaseItemQtyCount = (cart) => {
    return (cart.items || [])
      .filter((i) => !isCustomilyAddonLine(i))
      .reduce((sum, i) => sum + (i.quantity || 0), 0);
  };

  const updateCartCount = (count) => {
    const el = document.querySelector('.cart-count-js');
    if (!el) return;

    el.textContent = count;

    if (count > 0) {
      el.style.display = '';
      el.removeAttribute('style');
    } else {
      el.style.display = 'none';
    }
  };

  const fetchCart = async () => {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return await res.json();
  };

  // ---------- Free shipping ----------
  const updateFreeShipping = (cart) => {
    if (!root || !freeShipWrap || !freeShipMsg || !freeShipFill) return;

    const enabled = root.dataset.freeShippingEnabled === 'true';
    if (!enabled) {
      freeShipWrap.hidden = true;
      return;
    }

    const gbOnly = root.dataset.freeShippingGbOnly === 'true';
    const isGB = root.dataset.isGb === 'true';
    if (gbOnly && !isGB) {
      freeShipWrap.hidden = true;
      return;
    }

    const thresholdPounds = parseFloat(root.dataset.freeShippingThreshold || '0');
    const threshold = Math.round((Number.isFinite(thresholdPounds) ? thresholdPounds : 0) * 100);

    if (!threshold || threshold <= 0) {
      freeShipWrap.hidden = true;
      return;
    }

    const total = cart.total_price || 0;

    freeShipWrap.hidden = false;

    if (!cart.items || cart.items.length === 0) {
      freeShipMsg.textContent = `Free shipping for orders over ${moneyFormat(threshold)}`;
      freeShipFill.style.width = '0%';
      return;
    }

    if (total >= threshold) {
      freeShipMsg.textContent = `Congratulations! Free shipping with this order.`;
      freeShipFill.style.width = '100%';
      return;
    }

    const remaining = threshold - total;
    const pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));

    freeShipMsg.textContent = `You're only ${moneyFormat(remaining)} away from free shipping.`;
    freeShipFill.style.width = `${pct}%`;
  };

  // ---------- Render (merge customily add-ons into base line display) ----------
  const renderCart = (cart) => {
    if (noteEl) noteEl.value = cart.note || '';
    subtotalEl.textContent = moneyFormat(cart.items_subtotal_price);

    updateCartCount(getBaseItemQtyCount(cart));
    updateFreeShipping(cart);

    const isEmpty = !cart.items || !cart.items.length;
    if (summaryEl) summaryEl.hidden = isEmpty;

    if (isEmpty) {
      itemsWrap.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your cart is empty.</p>
          <button type="button" class="btn" data-cart-drawer-close style="margin-top:12px;">
            Continue shopping
          </button>
        </div>
      `;
      return;
    }

    const items = cart.items || [];

    // Build groups in cart order: base line + its attached Customily add-ons
    const groups = [];
    let lastCustomilyBaseGroup = null;

    items.forEach((it) => {
      if (isCustomilyAddonLine(it)) {
        if (lastCustomilyBaseGroup) {
          lastCustomilyBaseGroup.fees.push(it);
        } else {
          groups.push({ base: it, fees: [], isOrphanFee: true });
        }
        return;
      }

      const group = { base: it, fees: [], isOrphanFee: false };
      groups.push(group);

      if (isCustomilyBaseLine(it)) {
        lastCustomilyBaseGroup = group;
      }
    });

    itemsWrap.innerHTML = groups
      .map((g) => {
        const item = g.base;
        const isOrphanFee = g.isOrphanFee;

        const image = item.image ? `${item.image}&width=160` : '';
        const productUrl = item.url || '#';

        const variantTitle =
          item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

        const props = item.properties || {};
        const propsHtml = Object.keys(props)
          .filter((k) => props[k] !== null && props[k] !== '' && !k.startsWith('_'))
          .map((k) => `<div class="cart-drawer__prop"><small>${k}: ${String(props[k])}</small></div>`)
          .join('');

        const feeTotal = (g.fees || []).reduce((sum, f) => sum + (f.final_line_price || 0), 0);
        const mergedFinal = isOrphanFee ? item.final_line_price || 0 : (item.final_line_price || 0) + feeTotal;

        const hasDiscount = item.original_line_price > item.final_line_price;

        const feeKeysAttr = !isOrphanFee ? g.fees.map((f) => f.key).join('|') : '';

        return `
          <div class="cart-drawer__item" data-line="${item.key}" data-fee-keys="${feeKeysAttr}">
            <div>
              ${image ? `
                <a href="${productUrl}" class="cart-drawer__item-link">
                  <img src="${image}" alt="${item.product_title}">
                </a>
              ` : ``}
            </div>

            <div>
              <div>
                <a href="${productUrl}" class="cart-drawer__title-link">
                  <strong>${item.product_title}</strong>
                </a>
              </div>

              ${variantTitle ? `<div><small>${variantTitle}</small></div>` : ``}
              ${propsHtml ? `<div class="cart-drawer__props">${propsHtml}</div>` : ``}

              <div class="cart-drawer__actions" style="display:flex; align-items:center; justify-content:space-between; gap:10px; margin-top:8px;">
                <div style="display:flex; align-items:center; gap:10px;">
                  <div class="cart-drawer__qty">
                    <button type="button" data-qty-minus aria-label="Decrease quantity">−</button>
                    <input type="text" value="${item.quantity}" inputmode="numeric" pattern="[0-9]*" data-qty-input>
                    <button type="button" data-qty-plus aria-label="Increase quantity">+</button>
                  </div>

                  <button type="button" class="cart-drawer__remove" data-remove>Remove</button>
                </div>

                <div class="cart-drawer__price" style="text-align:right; line-height:1.2;">
                  ${hasDiscount ? `<small class="cart-drawer__price--was" style="display:block; opacity:0.7;"><s>${moneyFormat(item.original_line_price)}</s></small>` : ``}
                  <small class="cart-drawer__price--now" style="display:block;">${moneyFormat(mergedFinal)}</small>
                </div>
              </div>
            </div>
          </div>
        `;
      })
      .join('');
  };

  // ---------- refresh: latest-wins to prevent stale UI ----------
  let refreshToken = 0;

  const refresh = async () => {
    const token = ++refreshToken;
    const cart = await fetchCart();
    if (token === refreshToken) {
      renderCart(cart);
    }
    return cart;
  };

  // ---------- Cart endpoints ----------
  const changeLine = async (key, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('Failed to change line');
    return await res.json();
  };

  const addToCart = async (form) => {
    const formData = new FormData(form);

    const matchedVariant = syncVariantIdInput(form);
    if (matchedVariant) {
      formData.set('id', matchedVariant.id);
      updateVariantUrl(matchedVariant.id);
    } else {
      console.warn('No matching variant found from selected options');
    }

    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = parseInt(quantityInput?.value || '1', 10);
    formData.set('quantity', Number.isNaN(quantity) ? 1 : quantity);

    console.log('Submitting variant id:', formData.get('id'));
    console.log('Matched variant:', matchedVariant);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      console.warn('Failed to add to cart', error);
      return { ok: false, error };
    }

    return { ok: true, item: await res.json() };
  };

  const addVariantToCart = async (variantId, quantity) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity || 1 })
    });
    return res.ok;
  };

  const saveNote = async (note) => {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note })
    });
    if (!res.ok) throw new Error('Failed to save note');
    return await res.json();
  };

  // ---------- UI Handlers ----------
  overlay.addEventListener('click', closeDrawer);

  drawer.addEventListener('click', (e) => {
    if (e.target.matches('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('[data-cart-drawer-open]');
    if (!trigger) return;

    e.preventDefault();
    setLoading(true);
    try {
      await refresh();
      openDrawer();
    } finally {
      setLoading(false);
    }
  });

  // Keep hidden variant input + URL synced when options change
  document.addEventListener('change', (e) => {
    const optionInput = e.target.closest('[data-single-option-selector]');
    if (!optionInput) return;

    const form = optionInput.closest('form.product-form');
    if (!form) return;

    const matchedVariant = syncVariantIdInput(form);
    if (matchedVariant) {
      updateVariantUrl(matchedVariant.id);
      console.log('Variant changed to:', matchedVariant.id, matchedVariant.title);
    } else {
      console.warn('No variant matched on option change');
    }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('form.product-form')) return;
    if (form.hasAttribute('data-skip-cart-drawer')) return;

    e.preventDefault();

    setLoading(true);
    try {
      const added = await addToCart(form);
      if (!added.ok) {
        form.submit();
        return;
      }

      const addonToggle = form.querySelector('[data-addon-toggle]');
      if (addonToggle && addonToggle.checked) {
        await addVariantToCart('55416127160705', 1);
      }

      await refresh();
      openDrawer();
    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(false);
    }
  });

  // Qty/remove: apply to base + attached fee keys (Promise.all) + delayed refresh for app follow-ups
  itemsWrap.addEventListener('click', async (e) => {
    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;

    const parentKey = lineEl.getAttribute('data-line');
    const feeKeysRaw = lineEl.getAttribute('data-fee-keys') || '';
    const feeKeys = feeKeysRaw ? feeKeysRaw.split('|').filter(Boolean) : [];

    const qtyInput = lineEl.querySelector('[data-qty-input]');
    const currentQty = parseInt(qtyInput?.value || '1', 10);

    const applyQty = async (newQty) => {
      await Promise.all([changeLine(parentKey, newQty), ...feeKeys.map((fk) => changeLine(fk, newQty))]);
    };

    const doAfter = () => setTimeout(() => refresh().catch(() => {}), 250);

    setLoading(true);
    try {
      if (e.target.matches('[data-qty-minus]')) {
        await applyQty(Math.max(0, currentQty - 1));
        await refresh();
        doAfter();
      }

      if (e.target.matches('[data-qty-plus]')) {
        await applyQty(currentQty + 1);
        await refresh();
        doAfter();
      }

      if (e.target.matches('[data-remove]')) {
        await applyQty(0);
        await refresh();
        doAfter();
      }
    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(false);
    }
  });

  itemsWrap.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-qty-input]')) return;

    const lineEl = e.target.closest('[data-line]');
    if (!lineEl) return;

    const parentKey = lineEl.getAttribute('data-line');
    const feeKeysRaw = lineEl.getAttribute('data-fee-keys') || '';
    const feeKeys = feeKeysRaw ? feeKeysRaw.split('|').filter(Boolean) : [];

    let qty = parseInt(e.target.value || '1', 10);
    if (Number.isNaN(qty) || qty < 0) qty = 1;

    const doAfter = () => setTimeout(() => refresh().catch(() => {}), 250);

    setLoading(true);
    try {
      await Promise.all([changeLine(parentKey, qty), ...feeKeys.map((fk) => changeLine(fk, qty))]);
      await refresh();
      doAfter();
    } catch (err) {
      console.warn(err);
    } finally {
      setLoading(false);
    }
  });

  drawer.addEventListener('click', async (e) => {
    if (!e.target.matches('[data-cart-note-save]')) return;
    e.preventDefault();

    setLoading(true);
    try {
      await saveNote(noteEl ? noteEl.value : '');
      showNoteStatus('Order note saved!');
      await refresh();
      setTimeout(() => refresh().catch(() => {}), 200);
    } catch (err) {
      console.warn(err);
      showNoteStatus('Sorry — note could not be saved. Please try again.');
    } finally {
      setLoading(false);
    }
  });

  const initUpsells = () => {
    if (!upsellWrap) return;

    const enabled = root?.dataset.upsellEnabled === 'true';
    if (!enabled) return;

    const track = upsellWrap.querySelector('[data-upsell-track]');
    const slides = upsellWrap.querySelectorAll('[data-upsell-slide]');
    if (!track || !slides.length) return;

    let index = 0;

    const goTo = (i) => {
      index = Math.max(0, Math.min(slides.length - 1, i));
      track.style.transform = `translateX(-${index * 100}%)`;
    };

    upsellWrap.addEventListener('click', async (e) => {
      if (e.target.matches('[data-upsell-prev]')) goTo(index - 1);
      if (e.target.matches('[data-upsell-next]')) goTo(index + 1);

      const atc = e.target.closest('[data-upsell-atc]');
      if (atc) {
        const variantId = atc.getAttribute('data-variant-id');
        if (!variantId) return;

        atc.disabled = true;
        setLoading(true);

        try {
          const ok = await addVariantToCart(variantId, 1);
          if (ok) {
            await refresh();
            openDrawer();
            setTimeout(() => refresh().catch(() => {}), 200);
          }
        } catch (err) {
          console.warn(err);
        } finally {
          setLoading(false);
          atc.disabled = false;
        }
      }
    });

    goTo(0);
  };

  initUpsells();

  // iOS Safari: force checkout navigation from drawer footer
  document.addEventListener('click', (e) => {
    const checkout = e.target.closest('#CartDrawerCheckout');
    if (!checkout) return;

    e.preventDefault();
    window.location.href = checkout.getAttribute('href') || '/checkout';
  });

  // Initial sync
  refresh().catch(() => {});
})();